import React from 'react';
import '../App.css';

export const Display = (props) => {
  return <div className="display">{props.display}</div>;
};